module.exports = __webpack_public_path__ + "static/media/logo-light.97056929.svg";